import { atom } from "jotai";
import type { ClientDTO } from "@/api/types/clients.types";
import { DEFAULT_CLIENTS } from "@/lib/constants/clients";

export const clientsAtom = atom<ClientDTO[]>(DEFAULT_CLIENTS);
